import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MarkdownModule } from 'ngx-markdown';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@content-platform/web-angular-shared-util-pipes';
import { AppAutoCompleteModule } from '@content-platform/reusable-ui/custom-material-components';
import { NgPipesModule } from 'ngx-pipes';
import { UserSearchAdComponent } from './user-search-ad/user-search-ad.component';
import { MsGraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-ms-graph-api';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  imports: [
    CommonModule,
    MarkdownModule.forChild(),
    MatButtonModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatOptionModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    ScrollingModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    AppAutoCompleteModule,
    NgPipesModule,
    MsGraphApiModule
  ],
  declarations: [UserSearchAdComponent],
  exports: [UserSearchAdComponent],
  entryComponents: []
})
export class UserSearchAdModule {}
